var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGstIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48755 1.22656H4.50492C4.23037 1.22656 4.00781 1.44912 4.00781 1.72367V2.71788C4.00781 2.99242 4.23037 3.21498 4.50492 3.21498H7.48755C7.76209 3.21498 7.98465 2.99242 7.98465 2.71788V1.72367C7.98465 1.44912 7.76209 1.22656 7.48755 1.22656Z",
    stroke: "#111D31",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9887 2.22656H8.98291C9.24659 2.22656 9.49947 2.33131 9.68592 2.51776C9.87237 2.70421 9.97712 2.95709 9.97712 3.22077V9.80864C9.97712 10.0723 9.87237 10.3252 9.68592 10.5116C9.49947 10.6981 9.24659 10.8028 8.98291 10.8028H3.01765C2.75397 10.8028 2.50109 10.6981 2.31463 10.5116C2.12818 10.3252 2.02344 10.0723 2.02344 9.80864V3.22077C2.02344 2.95709 2.12818 2.70421 2.31463 2.51776C2.50109 2.33131 2.75397 2.22656 3.01765 2.22656H4.01186",
    stroke: "#111D31",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48868 5.5L4.5 8.48868",
    stroke: "#111D31",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50488 5.09961L4.58594 5.1084C4.76802 5.14584 4.90527 5.30684 4.90527 5.5C4.90527 5.69316 4.76802 5.85416 4.58594 5.8916L4.50488 5.90039H4.5C4.27909 5.90039 4.09961 5.72091 4.09961 5.5C4.09961 5.27909 4.27909 5.09961 4.5 5.09961H4.50488Z",
    stroke: "#111D31",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50488 8.09961L7.58594 8.1084C7.76802 8.14584 7.90527 8.30684 7.90527 8.5C7.90527 8.69316 7.76802 8.85416 7.58594 8.8916L7.50488 8.90039H7.5C7.27909 8.90039 7.09961 8.72091 7.09961 8.5C7.09961 8.27909 7.27909 8.09961 7.5 8.09961H7.50488Z",
    stroke: "#111D31",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstIcon);
export default __webpack_public_path__ + "static/media/GSTIcon.c7757cb2c6553301115185b4ce899cab.svg";
export { ForwardRef as ReactComponent };